import { render, staticRenderFns } from "./NavbarCollapse.vue?vue&type=template&id=b87b353c&scoped=true&"
import script from "./NavbarCollapse.vue?vue&type=script&lang=js&"
export * from "./NavbarCollapse.vue?vue&type=script&lang=js&"
import style0 from "./NavbarCollapse.vue?vue&type=style&index=0&id=b87b353c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87b353c",
  null
  
)

export default component.exports